module.exports = __webpack_public_path__ + "static/media/22.d5037d49.png";